import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons'

import Button from 'components/Button'
import FormField from 'components/forms/FormField'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import CustomSectionWrapper from 'agency/digital_renderer/components/CustomSectionWrapper'
import CustomSectionsWrapper from 'agency/digital_renderer/components/CustomSectionsWrapper'

// eslint-disable-next-line import/no-cycle
import ElementContainer from '../../ElementContainer'

import AddLink from './AddLink'
import styles from './styles.scss'

const findContainer = items => items.find(item => item.item_type === 'container')

const renderItems = (container, params, contextData) => {
  const { sections } = params
  const { dataSource, dataSourceType, editing: editMode } = contextData

  return sections.map(section => (
    <CustomSectionWrapper
      customSection={section}
      dataSource={dataSource}
      dataSourceType={dataSourceType}
      editMode={editMode}
      key={section.id}
      render={(renderProps) => {
        const {
          callbacks: {
            createLink, deleteLink, deleteSection, reset, toggleEdit, updateSection,
          },
          deleting,
          editing,
          setState,
          state: { body, data, title },
          updating,
        } = renderProps

        const { external_links } = data || {}

        return (
          <div className={styles.section} key={section.id} style={deviceStyle(container)}>
            {editMode && !editing && (
              <a className={styles.editSection} onClick={toggleEdit} tabIndex="0">
                <FontAwesomeIcon icon={faPencil} /> Edit Section
              </a>
            )}

            {editing && (
              <div className={styles.editing}>
                <FormField label="Title">
                  <input type="text" value={title} onChange={e => setState({ title: e.target.value })} />
                </FormField>

                <FormField label="Body">
                  <textarea value={body} onChange={e => setState({ body: e.target.value })} style={{ height: 140 }} />
                </FormField>

                {external_links && !!external_links.length && (
                  <FormField label="Links">
                    {external_links.map(link => (
                      <Button
                        color="darkLightBorder"
                        ghost
                        icon={<FontAwesomeIcon icon={faTrashAlt} />}
                        key={link.key}
                        onClick={() => deleteLink(link)}
                        size="small"
                        style={{ margin: '0 5px 15px 0' }}
                        text={`${link.title} (Delete)`}
                      />
                    ))}
                  </FormField>
                )}

                <FormField label="Add Link">
                  <AddLink callbacks={{ createLink }} />
                </FormField>

                <div className={styles.buttons} style={{ marginTop: 15 }}>
                  <Button color="green" loading={updating} size="medium" text="Save" onClick={updateSection} />

                  <Button
                    color="red"
                    ghost
                    loading={deleting}
                    size="medium"
                    style={{ marginLeft: 5 }}
                    text="Delete"
                    onClick={() => deleteSection(section)}
                  />

                  <Button
                    color="grey"
                    ghost
                    size="medium"
                    style={{ marginLeft: 5 }}
                    text="Cancel"
                    onClick={reset}
                  />
                </div>
              </div>
            )}

            {!editing && (
              <ElementContainer
                forwardContextToItems={section}
                section={container}
                renderNested
                render={({ itemComponents }) => itemComponents.map(component => component)}
              />
            )}
          </div>
        )
      }}
    />
  ))
}

const CustomSections = (props) => {
  const {
    context: componentContext,
    items,
  } = props

  // Context
  const defaultContext = useContext(GlobalContext)
  const contextData = { ...defaultContext, ...componentContext }
  const { dataSource, dataSourceType, editing } = contextData

  const container = findContainer(items) || {}

  return (
    <CustomSectionsWrapper
      dataSource={dataSource}
      dataSourceType={dataSourceType}
      render={(params) => {
        const { createSection, creatingSection } = params
        return (
          <div className={styles.root} style={deviceStyle(props)}>
            {renderItems(container, params, contextData)}

            {editing && (
              <Button
                disabled={creatingSection}
                ghost
                loading={creatingSection}
                onClick={createSection}
                size="medium"
                style={{ marginBottom: 15 }}
                text="Add Section"
              />
            )}
          </div>
        )
      }}
    />
  )
}

CustomSections.propTypes = {
  context: PropTypes.object,
  items: PropTypes.array,
}

export default CustomSections
